/* HotDawgs — product page
   Native Shopify variant picker: matches the selected pills/swatches to a
   real variant, swaps the gallery image to that variant's own photo (or
   its color's photo) instead of hitting the Storefront API for it, and
   adds to cart through the theme's Ajax Cart (assets/cart.js). */

(function () {
  const root = document.getElementById('pd-root');
  if (!root) return;

  const jsonEl = document.getElementById('pd-product-json');
  const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
  const params = new URLSearchParams(window.location.search);
  const presetSize = params.get('size');
  const presetName = params.get('name');

  const state = { selectedOptions: {} };

  const els = {
    priceNow: document.getElementById('pd-price-now'),
    priceWas: document.getElementById('pd-price-was'),
    gallery: document.getElementById('pd-gallery'),
    mainImg: document.getElementById('pd-main-img'),
    thumbs: document.getElementById('pd-thumbs'),
    addBtn: document.getElementById('pd-add-btn'),
    banner: document.getElementById('pd-personal-banner'),
    sizePrompt: document.getElementById('pd-size-prompt'),
    qty: document.getElementById('pd-qty'),
    variantSelect: document.getElementById('pd-variant-select'),
    upsell: document.getElementById('pd-upsell'),
    upsellCheckbox: document.getElementById('pd-upsell-checkbox'),
    form: document.getElementById('pd-product-form'),
    stickyBar: document.getElementById('pd-sticky-bar'),
    stickyTitle: document.getElementById('pd-sticky-title'),
    stickyPrice: document.getElementById('pd-sticky-price'),
    stickyAddBtn: document.getElementById('pd-sticky-add-btn'),
  };

  // Known swatch colors — extend if more colorways get added in Shopify.
  const COLOR_SWATCHES = {
    grey: '#9C958B', gray: '#9C958B',
    beige: '#D9C6A3',
    black: '#1a1a1a', white: '#f5f2ec',
    brown: '#7a5230', tan: '#D9C6A3',
  };

  function money(cents) {
    const symbol = (window.HD && window.HD.settings && window.HD.settings.cartCurrency) || '$';
    return `${symbol}${(cents / 100).toFixed(2)}`;
  }

  function paintSwatches() {
    root.querySelectorAll('.color-swatch[data-swatch-color]').forEach((el) => {
      const hex = COLOR_SWATCHES[el.dataset.swatchColor];
      if (hex) {
        el.style.background = hex;
      } else {
        el.style.background = 'var(--cream-dim)';
        el.style.fontSize = '10px';
        el.textContent = (el.dataset.value || '').slice(0, 2).toUpperCase();
        el.style.display = 'flex';
        el.style.alignItems = 'center';
        el.style.justifyContent = 'center';
      }
    });
  }

  // Seed state.selectedOptions from whichever pill/swatch is already marked
  // .selected server-side (the current/first-available variant).
  function seedStateFromDom() {
    root.querySelectorAll('.pd-option-group').forEach((group) => {
      const name = group.dataset.optionName;
      const selected = group.querySelector('.pd-option-value.selected');
      if (selected) state.selectedOptions[name] = selected.dataset.value;
    });
  }

  function findMatchingVariant() {
    const groups = [...root.querySelectorAll('.pd-option-group')];
    return variants.find((v) =>
      v.options.every((val, i) => {
        const name = groups[i] ? groups[i].dataset.optionName : null;
        return !name || state.selectedOptions[name] === val;
      })
    );
  }

  function applyPresetSize() {
    if (!presetSize) return;
    const group = root.querySelector('.pd-option-group');
    if (!group) return;
    const target = [...group.querySelectorAll('.pd-option-value')]
      .find((el) => el.dataset.value.toLowerCase() === presetSize.toLowerCase());
    if (target) {
      selectOption(target);
    }
  }

  function selectOption(btn) {
    const group = btn.closest('.pd-option-group');
    state.selectedOptions[btn.dataset.optionName] = btn.dataset.value;
    group.querySelectorAll('.pd-option-value').forEach((el) => el.classList.remove('selected'));
    btn.classList.add('selected');
    render();
  }

  function render() {
    const variant = findMatchingVariant();
    if (!variant) return;

    if (els.variantSelect) els.variantSelect.value = variant.id;
    if (els.priceNow) els.priceNow.textContent = money(variant.price);
    if (els.priceWas) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        els.priceWas.textContent = money(variant.compare_at_price);
        els.priceWas.style.display = 'inline';
      } else {
        els.priceWas.style.display = 'none';
      }
    }
    if (els.addBtn) {
      els.addBtn.disabled = !variant.available;
      els.addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    if (els.stickyPrice) els.stickyPrice.textContent = money(variant.price);

    // Swap gallery to this variant's own photo, if one is assigned in Admin.
    if (variant.featured_image && els.mainImg) {
      els.mainImg.src = variant.featured_image.src;
      if (els.thumbs) {
        els.thumbs.querySelectorAll('.pd-thumb').forEach((t) => {
          t.classList.toggle('active', String(t.dataset.mediaId) === String(variant.featured_image.id));
        });
      }
    }
  }

  root.querySelectorAll('.pd-option-value').forEach((btn) => {
    btn.addEventListener('click', () => selectOption(btn));
  });

  els.thumbs?.querySelectorAll('.pd-thumb').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (els.mainImg) els.mainImg.src = btn.dataset.src;
      els.thumbs.querySelectorAll('.pd-thumb').forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  function renderPersonalBanner() {
    if (!presetName || !els.banner) return;
    els.banner.style.display = 'block';
    els.banner.innerHTML = `\u{1F525} Picked for <strong>${presetName}</strong> \u2014 sizing pre-selected to <strong>${presetSize}</strong>.`;
    if (els.sizePrompt) els.sizePrompt.style.display = 'none';
  }

  els.form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const variant = findMatchingVariant();
    if (!variant || !variant.available || typeof HdCart === 'undefined') return;
    const qty = parseInt(els.qty?.value || '1', 10);
    await HdCart.addLine(variant.id, qty);
    if (els.upsellCheckbox?.checked && window.HD?.settings) {
      const blanketVariantId = els.upsell?.dataset.blanketVariantId;
      if (blanketVariantId) await HdCart.addLine(blanketVariantId, 1);
    }
  });

  els.stickyAddBtn?.addEventListener('click', () => els.form?.requestSubmit());

  document.getElementById('pd-owner-add-btn')?.addEventListener('click', () => {
    if (els.upsellCheckbox) els.upsellCheckbox.checked = true;
    els.upsell?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    els.upsell?.classList.add('pd-upsell-flash');
    setTimeout(() => els.upsell?.classList.remove('pd-upsell-flash'), 900);
  });

  // Show the sticky buy bar once the main "Add to cart" button scrolls out of view.
  if (els.addBtn && els.stickyBar) {
    const observer = new IntersectionObserver(
      ([entry]) => els.stickyBar.classList.toggle('visible', !entry.isIntersecting),
      { rootMargin: '0px 0px -20% 0px' }
    );
    observer.observe(els.addBtn);
  }

  paintSwatches();
  seedStateFromDom();
  applyPresetSize();
  renderPersonalBanner();
  render();
})();
